import { NextStepBlock } from '@squareup/dex-ui';
import { Box } from '@squareup/dex-ui-shared-base';
import React, { FC } from 'react';

interface MdxNextStepBlockProps {
  previousTitle?: string;
  previousUrl?: string;
  nextTitle?: string;
  nextUrl?: string;
}

const MdxNextStepBlock: FC<MdxNextStepBlockProps> = ({
  previousTitle,
  previousUrl,
  nextTitle,
  nextUrl,
}) => {
  const previous =
    previousTitle && previousUrl
      ? { title: previousTitle, url: previousUrl }
      : undefined;
  const next =
    nextTitle && nextUrl ? { title: nextTitle, url: nextUrl } : undefined;

  if (!previous && !next) {
    return null;
  }

  return (
    <Box margin={{ top: '5x' }}>
      <NextStepBlock previous={previous} next={next} />
    </Box>
  );
};

MdxNextStepBlock.displayName = 'MdxNextStepBlock';

export { MdxNextStepBlock };
